import { AssertionDescriptors } from '../../utilities/Constants';

//// These are used to lock certain ADs in same case group scenarios
export const lockableAssertionDescriptors = [
    AssertionDescriptors.Jurisdiction.Guid,
    AssertionDescriptors.InjuredPartyFirstName.Guid,
    AssertionDescriptors.InjuredPartyLastName.Guid,
];
